import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f8be4a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center" }
const _hoisted_2 = { class: "text-center fw-bold mb-0" }
const _hoisted_3 = { class: "p-lg-5 text-center bg-white user-container shadow my-lg-5 fs-5 fw-bold" }
const _hoisted_4 = { class: "text-number" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 1 }

import TabPanel from '@/components/tabs/panel/TabPanel.vue'
import Tabs from '@/components/tabs/index.vue'
// import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import usersServices from '@/services/users.service.ts'
import { translate } from '@/languages/i18n'
import { watchEffect, ref } from 'vue'
import { useRoute } from 'vue-router'
import ListUsers from './components/ListUsers.vue'
import { numberWithCommas } from '@/constants/common.ts'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const data = ref({})
const loadingListUser = ref(false)

//TODO: SQ10
watchEffect(async () => {
  if (route?.params?.id) {
    loadingListUser.value = true
    try {
      const response = await usersServices.getListUsersApi(route?.params?.id, { user_type: route?.query?.tab || 'all' })
      data.value = response?.data?.data
      loadingListUser.value = false
    } catch (error) {
      loadingListUser.value = false
      console.log(error)
    }
  }
})

const tabs = [
  {
    title: translate('all'),
    alias: 'all',
  },
  {
    title: translate('almunai'),
    alias: 'alumni',
  },
  {
    title: '在籍者',
    alias: 'employee',
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('communityMember')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_unref(translate)('participantGroup')) + " : ", 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(numberWithCommas)(data.value?.member_number)), 1),
      _createElementVNode("span", null, _toDisplayString(_unref(translate)('name')), 1)
    ]),
    _createVNode(Tabs, {
      tabs: tabs,
      "default-alias": 'all'
    }, {
      default: _withCtx(() => [
        _createVNode(TabPanel, {
          alias: 'all',
          keyName: 1
        }, {
          default: _withCtx(() => [
            (loadingListUser.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true),
            (!loadingListUser.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(ListUsers, { listUsers: data.value }, null, 8, ["listUsers"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(TabPanel, {
          alias: 'alumni',
          keyName: 2
        }, {
          default: _withCtx(() => [
            (loadingListUser.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            (!loadingListUser.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(ListUsers, { listUsers: data.value }, null, 8, ["listUsers"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(TabPanel, {
          alias: 'employee',
          keyName: 3
        }, {
          default: _withCtx(() => [
            (loadingListUser.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true),
            (!loadingListUser.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(ListUsers, { listUsers: data.value }, null, 8, ["listUsers"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})